import hostname from './config.host';
import { fetchWrapper } from './fetch-wrapper';
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getDashboadExecuteQuery(
    oauthTokenHeader: string,
    website_shared_uid: string,
    start_date: any,
    end_date: any,
    QUERY_ID: any,
    device: any
  ) {
    return fetchWrapper.get(
      `${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${start_date}&end_date=${end_date}&website_shared_uid=${website_shared_uid}&device=${device}`,
      oauthTokenHeader
    );
  }

  export const pageSpeedPerformanceService = {
    getDashboadExecuteQuery
  }